var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83984 6.16848C1.42563 6.16848 1.08984 6.50428 1.08984 6.91848C1.08984 7.33268 1.42563 7.66848 1.83984 7.66848V6.16848ZM17.3702 7.44883C17.663 7.15593 17.663 6.68103 17.3702 6.38813L12.5972 1.61518C12.3043 1.32228 11.8294 1.32228 11.5365 1.61518C11.2436 1.90807 11.2436 2.38294 11.5365 2.67584L15.7792 6.91848L11.5365 11.1611C11.2436 11.454 11.2436 11.9289 11.5365 12.2218C11.8294 12.5147 12.3043 12.5147 12.5972 12.2218L17.3702 7.44883ZM1.83984 7.66848H16.8398V6.16848H1.83984V7.66848Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 12,
    fill: "white",
    transform: "translate(0.839844 0.918457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.5de4388131d1c4f18a3c066dc3936766.svg";
export { ForwardRef as ReactComponent };